import { Flex } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { devicesApi } from '~/apis/devicesApi'
import { pbxSettingsApi } from '~/apis/pbxSettingsApi'
import { useUserState } from '~/atoms/UserState'
import { toaster } from '~/components/ui/toaster'
import { isMangoStaffOrSuperuser } from '~/utils/auth'

import { PbxSettingsPage } from '@mangovoice/pbx-settings-ui'

export const PbxSettingsSettingsPage = () => {
  const { t } = useTranslation()
  const { pbxId, userRoles } = useUserState({ canAutoRefresh: false })
  const isInternalUser = isMangoStaffOrSuperuser(userRoles)

  const handleRebuildAndRebootDevices = async (targetPbxId: number) => {
    const response = await devicesApi.rebuildAndRebootDevices(targetPbxId)
    if (!response.ok) {
      throw response.data ?? new Error('Failed to rebuild and reboot devices')
    }
  }

  return (
    <Flex direction="column" flex={1} minH={0} p={6} overflowY="auto">
      <PbxSettingsPage
        api={pbxSettingsApi}
        pbxId={pbxId}
        toast={toaster}
        isInternalUser={Boolean(isInternalUser)}
        onRebuildAndRebootDevices={handleRebuildAndRebootDevices}
        t={t}
      />
    </Flex>
  )
}
